import { useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';

import AtomGrid from '../../../../components/atoms/AtomGrid';
import { styleConfigs } from '../../../../components/resources/styleConfigs';
import palette from '../../../../theme/learnerPalette';

export const RootStyled = styled(AtomGrid)(() => ({
  height: styleConfigs.dimensions.height100vh,
  display: 'flex',
  [useTheme().breakpoints.down('md')]: {
    height: styleConfigs.dimensions.height100dvh,
  },
  [useTheme().breakpoints.down('sm')]: {
    height: styleConfigs.dimensions.height100svh,
  },
}));

export const MainStyled = styled(AtomGrid)(() => ({
  flexGrow: 1,
  position: 'relative',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: palette.light.background.alabaster,
}));

export const ScrollableContentStyled = styled(AtomGrid)(({ isfloatingbutton }: { isfloatingbutton?: number }) => ({
  flexGrow: 1,
  overflowY: 'scroll',
  paddingTop: styleConfigs.marginPadding.custom88,
  paddingBottom: isfloatingbutton ? styleConfigs.marginPadding.custom141 : styleConfigs.marginPadding.custom88,
  paddingInline: styleConfigs.marginPadding.custom16,
  transition: useTheme().transitions.create('padding', {
    duration: useTheme().transitions.duration.complex,
  }),
  [useTheme().breakpoints.up('sm')]: {
    paddingBottom: isfloatingbutton ? styleConfigs.marginPadding.custom131 : styleConfigs.marginPadding.custom88,
    paddingInline: styleConfigs.marginPadding.custom24,
  },
  [useTheme().breakpoints.up('lg')]: {
    paddingTop: styleConfigs.marginPadding.custom116,
    paddingInline: styleConfigs.marginPadding.custom40,
  },
}));
